<sbnb-partner-discount-details-banner
  *ngIf="form.controls.code.value"
  [code]="form.controls.code.value"
  class="mb-8"></sbnb-partner-discount-details-banner>

<h1 class="mb-8 text-2xl md:text-3xl">Start your free trial below</h1>

<form [formGroup]="form">
  <label class="text-sm font-bold block text-night" for="email">Email</label>
  <mat-form-field class="w-full">
    <input
      matInput
      type="email"
      name="email"
      formControlName="email"
      [placeholder]="config.EMAIL_PLACEHOLDER"
      (input)="revertAction()" />
    <mat-error *ngIf="form.controls.email.errors?.required">Email {{ 'CORE.IS_REQUIRED' | transloco }}</mat-error>
    <mat-error *ngIf="form.controls.email.errors?.email">{{ 'CORE.VALID_EMAIL' | transloco }}</mat-error>
    <mat-error *ngIf="form.controls.email.errors?.custom">{{ form.controls.email.errors.custom }}</mat-error>
  </mat-form-field>

  <mat-checkbox formControlName="agreeToTerms" class="text-sm mb-5">
    I agree to the
    <a [href]="config.TOS_URL" target="_blank" class="link">Terms of Service</a>
    <span class="px-0.5">and</span>
    <a [href]="config.PRIVACY_POLICY_URL" target="_blank" class="link">Privacy Policy</a>
  </mat-checkbox>

  <sbnb-button
    *ngIf="action === 'existing'"
    [fullWidth]="true"
    [routerLink]="['/user/hello', signupUserService.user$.value?.email]">
    Take me to login
  </sbnb-button>

  <sbnb-button *ngIf="action === 'guide'" [fullWidth]="true" (click)="guideInvited()">Please guide me</sbnb-button>

  <sbnb-button
    *ngIf="action === 'continue'"
    [fullWidth]="true"
    [disabled]="form.invalid"
    [loading]="createLoading || validateLoading"
    (clicked)="onContinue()">
    Continue
  </sbnb-button>
</form>

<div class="relative flex py-5 items-center">
  <div class="flex-grow border-t border-smoke"></div>
  <span class="flex-shrink mx-4 text-night-lighter">or</span>
  <div class="flex-grow border-t border-smoke"></div>
</div>

<sbnb-button [fullWidth]="true" type="secondary" routerLink="airbnb" icon="airbnb-rose" [preserveIconColor]="true">
  Continue with Airbnb
</sbnb-button>

<span *ngIf="airbnbErrorMessage" class="text-raspberry-darker block mt-6">
  {{ airbnbErrorMessage }}
</span>

<re-captcha
  class="hidden"
  #captchaRef="reCaptcha"
  siteKey="6LfeJaQUAAAAAIQ_vByLDLtykLj658FY9Fh4CYBs"
  size="invisible"
  (resolved)="$event && createNewUser()"></re-captcha>
